<div nz-row class="h-screen bg-white overflow-hidden">
  <div
    nz-col
    nzXs="24"
    nzLg="14"
    class="h-screen overflow-y-auto py-8 pb-10 px-12 flex flex-col gap-6"
  >
    <svg-icon src="assets/svg/logo.svg" [svgStyle]="{ 'height.px': 54, width: 'auto' }" />

    <div class="min-h-[calc(100vh-150px)] w-full flex justify-center items-center mt-4">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div nz-col nzLg="10" class="h-screen w-full relative">
    <img
      priority
      alt="auth layout background"
      ngSrc="assets/svg/auth-layout-pattern-bg.svg"
      fill
      class="object-cover object-center"
    />

    <div
      class="absolute inset-0 flex flex-col gap-2 items-center justify-center max-w-106.5 mx-auto"
    >
      <img
        priority
        alt="laptop on desk"
        ngSrc="assets/image/laptop-on-desk.png"
        width="297"
        height="254"
        class=""
      />

      <p class="font-bold text-xl text-center leading-['1.5'] text-white">
        Digitize, organize, secure and automate your document workflows
      </p>

      <p class="text-base text-center leading-['1.5'] text-body-white">
        Transforming complex paper trails into seamless, high-speed digital operations
      </p>
    </div>
  </div>
</div>
